import { render, staticRenderFns } from "./bag-model-quantity-justify-dialog.vue?vue&type=template&id=24d85b88&scoped=true&lang=pug&"
import script from "./bag-model-quantity-justify-dialog.vue?vue&type=script&lang=ts&"
export * from "./bag-model-quantity-justify-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d85b88",
  null
  
)

export default component.exports